import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicInputNumber extends DesigntimeComponent {
    static staticName = "Logic: Input(Number)";
    static staticId = "logicInputNumber";
    hasRuntimeView = false;

    inputFound = false;

    constructor(identifyer) {
        super(identifyer, 1);
        this.values = {
            inputName: { value: "monthlySpending", dontTranslate: true },
            defaultValue: { value: 1, dontTranslate: true }
        };
    }

    getRuntimeView(context) {
        this.eventBroker.subscribe("readyToShowEvent", this.showDefault.bind(this))
        return $("<div class='logicParameter'></div>");
    }

    showDefault() {
        if (this.inputFound) return;

        let params = new URLSearchParams(document.location.search);
        let inputValue = params.get(this.values.inputName.value);
        if (inputValue) {
            let inputValueNumber = parseInt(inputValue, 10);
            this.eventBroker.fireValueChanged(this.id, "input", inputValueNumber);
            return;
        }

        this.eventBroker.fireValueChanged(this.id, "input", this.values.defaultValue.value);
    }

    onRuntimeChanged(eventParams) {
        if (eventParams.key == "url:" + this.values.inputName.value) {
            this.inputFound = true;
            this.eventBroker.fireValueChanged(this.id, "input", eventParams.value);
        }
    }

    output = [{ name: "input", type: "number" }]
}

export { LogicInputNumber }
